import { color } from "@styles";
import { FC, ChangeEvent } from "react";
import styled, { css } from "styled-components";
import { Check } from "./svgs/Check";
import { Cross } from "./svgs/Cross";
import { visuallyHidden } from "./VisuallyHidden";

interface Props {
  checked: boolean;
  onCheck: (checked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
  label?: string;
}

export const Toggle: FC<Props> = ({ checked, onCheck, label }) => (
  <CheckboxWrapper>
    <Legend>{`Toggle ${label}`}</Legend>
    <StyledCheck aria-hidden="true" checked={checked} color={color.S3100} />
    <Checkbox
      id={`checkbox-${label}`}
      checked={checked}
      onChange={(event) => onCheck(event.target.checked, event)}
      type="checkbox"
    />
    <CheckboxLabel htmlFor={`checkbox-${label}`} />
    <StyledCross aria-hidden="true" checked={checked} color={color.S3100} />
  </CheckboxWrapper>
);

const iconPosition = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  pointer-events: none;
`;

const StyledCheck = styled(Check)<{ checked: boolean }>`
  ${iconPosition};
  left: 5px;
  opacity: ${({ checked }) => (checked ? 1 : 0)};
`;

const StyledCross = styled(Cross)<{ checked: boolean }>`
  ${iconPosition};
  right: 5px;
  opacity: ${({ checked }) => (checked ? 0 : 1)};
`;

const CheckboxWrapper = styled.fieldset`
  position: relative;
  height: 24px;
  border: 0;
  padding: 0;
  margin: 0;
`;

const Legend = styled.legend`
  ${visuallyHidden};
`;

const transition = css`
  transition: margin 0.2s ease-in-out;
  @media (prefers-reduced-motion: reduce) {
    transition-duration: 0ms;
  }
`;

const CheckboxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 24px;
  border-radius: 15px;
  background: white;
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin: 2px;
    background: ${color.S3100};
    ${transition};
  }

  @media (prefers-reduced-motion: reduce) {
    transition-duration: 0ms;
  }
`;
const Checkbox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 42px;
  height: 24px;
  &:focus + ${CheckboxLabel} {
    outline: 1px auto -webkit-focus-ring-color; /* 1 */
  }
  &:checked + ${CheckboxLabel} {
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      margin-left: 26px;
      ${transition};
    }
  }
`;
